export function getDraggingCellRowStyle(style) {
  return {
    ...style,
    backgroundColor: 'var(--color-bg-surface)',
    borderRadius: '4px',
    boxSizing: 'border-box',
    maxWidth: 616,
    minWidth: 616,
    pointerEvents: 'none',
    width: 616,
  }
}
